import Vue from 'vue'
import qs from 'qs'

export default {
  list (from, to, page, limit, order, sort, filters, by, config = {}) {
    return Vue.http.get('/rental/transactions', {
      params: {
        from,
        to,
        page,
        limit,
        order,
        sort,
        filters,
        by
      },
      paramsSerializer: qs.stringify,
      ...config
    })
  },

  listUsers (params) {
    return Vue.http.get('/rental/transaction_users', {
      params,
      paramsSerializer: qs.stringify,
    })
  },
}



// WEBPACK FOOTER //
// ./src/services/rental/transaction.js